// extracted by mini-css-extract-plugin
export var active = "_k8-2";
export var recordingDot = "_k8-1";
export var recordingIndicator = "_k8-0";